var _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _g2, _path, _path2, _path3, _path4, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPayshapInfo2 = function SvgPayshapInfo2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 7.48633,
    width: 34,
    height: 22,
    rx: 3,
    stroke: "#F15A22",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 15.4863,
    width: 12,
    height: 2,
    fill: "#FC4D0F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 20.4863,
    width: 10,
    height: 2,
    fill: "#FC4D0F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3168_6858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5273 23.7363H40.4718",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 21.2086V17.9031",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.834 21.2086V17.9031",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.166 21.2086V17.9031",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 21.2086V17.9031",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7675 11.6524C35.9066 11.5531 36.0934 11.5531 36.2325 11.6524L41.1093 15.1358C41.426 15.362 41.2659 15.8613 40.8768 15.8613H31.1232C30.7341 15.8613 30.574 15.362 30.8907 15.1358L35.7675 11.6524Z",
    fill: "#F15A22"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 37.4863,
    width: 34,
    height: 22,
    rx: 3,
    stroke: "#F15A22",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45.4863,
    width: 12,
    height: 2,
    fill: "#FC4D0F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 50.4863,
    width: 10,
    height: 2,
    fill: "#FC4D0F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3168_6858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5273 53.7363H40.4718",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 51.2086V47.9031",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.834 51.2086V47.9031",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.166 51.2086V47.9031",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 51.2086V47.9031",
    stroke: "#F15A22",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7675 41.6524C35.9066 41.5531 36.0934 41.5531 36.2325 41.6524L41.1093 45.1358C41.426 45.362 41.2659 45.8613 40.8768 45.8613H31.1232C30.7341 45.8613 30.574 45.362 30.8907 45.1358L35.7675 41.6524Z",
    fill: "#F15A22"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24.4863C15.5228 24.4863 20 20.0092 20 14.4863C20 8.96348 15.5228 4.48633 10 4.48633C4.47715 4.48633 0 8.96348 0 14.4863C0 20.0092 4.47715 24.4863 10 24.4863Z",
    fill: "#F15A22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 16.4759V17.6802C14.0002 17.792 13.9773 17.9027 13.9324 18.0051C13.8875 18.1075 13.8217 18.1995 13.7391 18.2751C13.6566 18.3507 13.5591 18.4082 13.453 18.444C13.3469 18.4798 13.2344 18.4931 13.1229 18.4831C11.8851 18.3488 10.6962 17.9267 9.65156 17.2506C8.67969 16.6343 7.85571 15.812 7.23813 14.842C6.55834 13.7947 6.1353 12.6024 6.00326 11.3615C5.99321 11.2505 6.00643 11.1386 6.04208 11.033C6.07773 10.9273 6.13503 10.8303 6.21032 10.748C6.28562 10.6656 6.37727 10.5999 6.47943 10.5548C6.58159 10.5098 6.69203 10.4865 6.80372 10.4864H8.01043C8.20564 10.4844 8.39489 10.5534 8.5429 10.6805C8.69091 10.8075 8.78759 10.9839 8.81491 11.1768C8.86584 11.5623 8.9603 11.9407 9.09647 12.3049C9.15059 12.4486 9.1623 12.6047 9.13022 12.7549C9.09814 12.905 9.02361 13.0428 8.91547 13.1519L8.40462 13.6618C8.97723 14.6668 9.81103 15.4989 10.8181 16.0704L11.3289 15.5606C11.4383 15.4526 11.5763 15.3783 11.7268 15.3462C11.8772 15.3142 12.0336 15.3259 12.1776 15.3799C12.5426 15.5158 12.9217 15.6101 13.3079 15.6609C13.5033 15.6885 13.6817 15.7867 13.8093 15.9369C13.9369 16.0872 14.0046 16.279 13.9998 16.4759Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.4863H27",
    stroke: "#F15A22",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23.4863V45.4863C10 47.1432 11.3431 48.4863 13 48.4863H26",
    stroke: "#F15A22",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3168_6858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(29 11.4863)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3168_6858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(29 41.4863)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayshapInfo2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payshap_info_2.cf78817a.svg";
export { ForwardRef as ReactComponent };